<template>
  <v-select v-model="lang" rounded variant="solo" :items="items" hide-details :class="isEmbed ? 'select-embed' : ''">
    <template v-slot:selection="{ props, item }">
      <v-avatar color="grey-lighten-1">
        <v-img :src="item.raw.prependAvatar"></v-img>
      </v-avatar>
    </template>
    <template v-slot:item="{ props, item }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <v-avatar color="grey-lighten-1">
            <v-img :src="item.raw.prependAvatar"></v-img>
          </v-avatar>
        </template>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import thaiIcon from '../assets/flag/th-TH.svg'
import englishIcon from '../assets/flag/en-US.svg'
import laosIcon from '../assets/flag/lo.svg'
export default {
  props: {
    isEmbed: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      language: "appSetting/getLanguage",
    }),
  },
  data() {
    return {
      lang: 'th',
      items: [
        {
          value: 'th',
          local: 'th-TH',
          title: 'ภาษาไทย',
          prependAvatar: thaiIcon,
        }, {
          value: 'en',
          local: 'en-US',
          title: 'English',
          prependAvatar: englishIcon,
        }, {
          value: 'lo',
          local: 'lo-LA',
          title: 'ລາວ',
          prependAvatar: laosIcon,
        }
      ]
    }
  },
  mounted() {
    if (this.language) this.lang = this.language
  },
  watch: {
    lang: {
      handler(newLang, oldLang) {
        if (newLang && newLang != oldLang) {
          this.setLanguage(newLang)
          this.$i18n.locale = newLang
          this.$moment.locale(this.$helper.langToFullLang(newLang) || "en-US")
        }
      },
    },
    language: {
      handler(newLang) {
        if (this.lang != newLang)
          this.lang = newLang
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      setLanguage: "appSetting/setLanguage"
    })
  }
};
</script>

<style scoped lang="scss">
.v-select {
  margin-right: 15px;

  .v-avatar {
    height: 25px;
    width: 25px;
  }

  &.v-input :deep() {

    input,
    .v-field,
    .v-field__field,
    .v-field__input {
      min-height: 40px;
      height: 40px;
      padding-top: 0;
      padding-bottom: 0;
      padding-right: 0;
    }

    .v-field__append-inner {
      padding-right: 7px;
    }

    .v-select__selection {
      width: 100%;
      justify-content: center;
    }
  }
}

.v-select.select-embed {
  max-width: 78px;
  max-height: 40px;
  position: absolute;
  right: 0;
  top: 15px;
  z-index: 2;
}

.v-list-item {
  .v-avatar {
    height: 25px;
    width: 25px;
  }
}
</style>